
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/special/ctd-ild",
      function () {
        return require("private-next-pages/special/ctd-ild/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/special/ctd-ild"])
      });
    }
  